import React, { useState, useEffect } from 'react';
import BackofficeDetail from './backofficeDetail';
import { apiFetch } from './api';

const Backoffice = () => {
  const [bereiche, setBereiche] = useState([]);
  const [neuerBereich, setNeuerBereich] = useState(false);
  const [bearbeitenBereich, setBearbeitenBereich] = useState(null);
  const [aktiverBereich, setAktiverBereich] = useState(null);
  const [name, setName] = useState('');
  const [beschreibung, setBeschreibung] = useState('');
  const [loading, setLoading] = useState(true);

  const ladeBereiche = async () => {
    const response = await apiFetch('/backoffice');
    const data = await response.json();
    setBereiche(data);
    setLoading(false);
  };

  useEffect(() => {
    ladeBereiche();
  }, []);

  const bereichErstellen = async () => {
    if (!name) return;
    await apiFetch('/backoffice', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, beschreibung })
    });
    setName('');
    setBeschreibung('');
    setNeuerBereich(false);
    ladeBereiche();
  };

  const bereichSpeichern = async () => {
    if (!name) return;
    await apiFetch(`/backoffice/${bearbeitenBereich.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, beschreibung, notizen: bearbeitenBereich.notizen })
    });
    setName('');
    setBeschreibung('');
    setBearbeitenBereich(null);
    ladeBereiche();
  };

  const bereichLoeschen = async (id) => {
    await apiFetch(`/backoffice/${id}`, {
      method: 'DELETE'
    });
    ladeBereiche();
  };

  const bearbeitenOeffnen = (bereich) => {
    setBearbeitenBereich(bereich);
    setName(bereich.name);
    setBeschreibung(bereich.beschreibung || '');
    setNeuerBereich(false);
  };

  const formularSchliessen = () => {
    setNeuerBereich(false);
    setBearbeitenBereich(null);
    setName('');
    setBeschreibung('');
  };

  const zeigeFormular = neuerBereich || bearbeitenBereich;

  // Karteikarte anzeigen
  if (aktiverBereich) {
    return (
      <BackofficeDetail
        bereichId={aktiverBereich}
        onZurueck={() => {
          setAktiverBereich(null);
          ladeBereiche();
        }}
      />
    );
  }

  return (
    <div style={{ padding: '40px' }}>

      {/* Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '32px'
      }}>
        <div>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#1a1a1a',
            margin: '0 0 6px 0',
            letterSpacing: '-0.5px'
          }}>
            Backoffice
          </h2>
          <p style={{
            fontSize: '14px',
            color: '#9b9b9b',
            margin: 0
          }}>
            {bereiche.length} {bereiche.length === 1 ? 'Bereich' : 'Bereiche'}
          </p>
        </div>
        <button
          onClick={() => { setNeuerBereich(true); setBearbeitenBereich(null); setName(''); setBeschreibung(''); }}
          style={{
            padding: '8px 16px',
            backgroundColor: '#1a1a1a',
            color: '#ffffff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          + Neuer Bereich
        </button>
      </div>

      {/* Formular */}
      {zeigeFormular && (
        <div style={{
          backgroundColor: '#ffffff',
          border: '1px solid #efefef',
          borderRadius: '10px',
          padding: '24px',
          marginBottom: '16px'
        }}>
          <h3 style={{
            fontSize: '14px',
            fontWeight: '600',
            color: '#1a1a1a',
            margin: '0 0 16px 0'
          }}>
            {bearbeitenBereich ? 'Bereich bearbeiten' : 'Neuer Bereich'}
          </h3>
          <div style={{ marginBottom: '12px' }}>
            <label style={{
              display: 'block',
              fontSize: '11px',
              fontWeight: '500',
              color: '#6b6b6b',
              marginBottom: '6px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="z.B. Finanzen"
              style={{
                width: '100%',
                padding: '10px 14px',
                fontSize: '14px',
                border: '1px solid #e8e8e8',
                borderRadius: '8px',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{
              display: 'block',
              fontSize: '11px',
              fontWeight: '500',
              color: '#6b6b6b',
              marginBottom: '6px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Beschreibung
            </label>
            <input
              type="text"
              value={beschreibung}
              onChange={(e) => setBeschreibung(e.target.value)}
              placeholder="Kurze Beschreibung des Bereichs"
              style={{
                width: '100%',
                padding: '10px 14px',
                fontSize: '14px',
                border: '1px solid #e8e8e8',
                borderRadius: '8px',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={bearbeitenBereich ? bereichSpeichern : bereichErstellen}
              style={{
                padding: '8px 20px',
                backgroundColor: '#1a1a1a',
                color: '#ffffff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              {bearbeitenBereich ? 'Speichern' : 'Erstellen'}
            </button>
            <button
              onClick={formularSchliessen}
              style={{
                padding: '8px 20px',
                backgroundColor: 'transparent',
                color: '#6b6b6b',
                border: '1px solid #e8e8e8',
                borderRadius: '8px',
                fontSize: '13px',
                cursor: 'pointer'
              }}
            >
              Abbrechen
            </button>
          </div>
        </div>
      )}

      {/* Bereiche Liste */}
      {loading ? (
        <p style={{ color: '#9b9b9b', fontSize: '14px' }}>Lädt...</p>
      ) : bereiche.length === 0 ? (
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          padding: '60px 40px',
          border: '1px solid #efefef',
          textAlign: 'center'
        }}>
          <p style={{ color: '#9b9b9b', fontSize: '14px', margin: 0 }}>
            Noch keine Bereiche. Erstelle deinen ersten Bereich!
          </p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {bereiche.map((bereich) => (
            <div
              key={bereich.id}
              onClick={() => setAktiverBereich(bereich.id)}
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '10px',
                padding: '20px 24px',
                border: '1px solid #efefef',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer'
              }}
            >
              <div>
                <p style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#1a1a1a',
                  margin: '0 0 4px 0'
                }}>
                  {bereich.name}
                </p>
                {bereich.beschreibung && (
                  <p style={{
                    fontSize: '13px',
                    color: '#9b9b9b',
                    margin: 0
                  }}>
                    {bereich.beschreibung}
                  </p>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    bearbeitenOeffnen(bereich);
                  }}
                  style={{
                    padding: '4px 10px',
                    backgroundColor: 'transparent',
                    border: '1px solid #e8e8e8',
                    borderRadius: '6px',
                    fontSize: '11px',
                    color: '#6b6b6b',
                    cursor: 'pointer'
                  }}
                >
                  Bearbeiten
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    bereichLoeschen(bereich.id);
                  }}
                  style={{
                    padding: '4px 10px',
                    backgroundColor: 'transparent',
                    border: '1px solid #ffdddd',
                    borderRadius: '6px',
                    fontSize: '11px',
                    color: '#cc0000',
                    cursor: 'pointer'
                  }}
                >
                  Löschen
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Backoffice;